<template>
  <section class="secondary">
    <v-container class="py-15" fluid>
      <v-row justify="center" align="center" class="py-5">
        <div align="center">
          <v-col cols="10" md="5" class="ma-auto">
            <h1
              class="
                white--text
                text-h3 text-center text-xl-h2
                font-weight-thin
              "
            >
              {{ $t("sectores.titulo") }}
            </h1>
            <div v-scrollanimation class="hr verdeClaro my-5"></div>
            <p v-scrollanimation class="anim font-weight-thin white--text">
              {{ $t("sectores.texto") }}
            </p>
          </v-col>
        </div>
      </v-row>
      <v-row align="start" justify="center" class="mb-15">
        <v-col cols="10" md="6" class="d-flex justify-center align-ceneter">
          <v-row v-scrollanimation class="anim" align="start" justify="center">
            <v-col
              cols="5"
              md="3"
              class="d-flex flex-column justify-center align-center"
            >
              <v-sheet
                class="d-flex align-center justify-center pa-6"
                height="100"
                width="100"
                rounded="circle"
                color="transparent"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="37.011"
                  height="35.947"
                  viewBox="0 0 37.011 35.947"
                >
                  <g
                    id="Grupo_409"
                    data-name="Grupo 409"
                    transform="translate(140.429 -6.174)"
                  >
                    <g id="Grupo_352" data-name="Grupo 352">
                      <g id="Grupo_353" data-name="Grupo 353">
                        <path
                          id="vaca"
                          d="M-111.432,18.817c-.052-.129-.1-.263-.154-.385a15.1,15.1,0,0,0,3.414-11.054,1.348,1.348,0,0,0-1.483-1.2,1.348,1.348,0,0,0-.975.589,30.225,30.225,0,0,1-7.052,6.839,18.7,18.7,0,0,0-4.157-.336h-.25a18.641,18.641,0,0,0-4.157.336A30.225,30.225,0,0,1-133.3,6.771a1.348,1.348,0,0,0-1.869-.368,1.345,1.345,0,0,0-.589.975,15.1,15.1,0,0,0,3.413,11.049c-.07.154-.129.324-.192.487a11.524,11.524,0,0,0-7.343,1.494,1.348,1.348,0,0,0-.294,1.879,9.416,9.416,0,0,0,6.855,4.179c.027.317.044.624.082.952,1.27,10.791,4.492,13.676,8.3,14.4C-106.727,45.185-111.943,19.4-111.432,18.817Zm.919,4.923a17.319,17.319,0,0,0-.2-2.192,10.586,10.586,0,0,1,3.7.4,6.257,6.257,0,0,1-3.5,1.793Zm-.576-12.237a13.1,13.1,0,0,1-2.079,4.535,7.875,7.875,0,0,0-1.544-1.256,35.184,35.184,0,0,0,3.623-3.28Zm-18.143,3.28a7.85,7.85,0,0,0-1.54,1.256,13.091,13.091,0,0,1-2.079-4.536,35.235,35.235,0,0,0,3.618,3.28Zm-4,6.766a17.319,17.319,0,0,0-.2,2.192,6.264,6.264,0,0,1-3.5-1.791,10.563,10.563,0,0,1,3.7-.4Zm2.661,5.552c-.5-4.261.044-7.318,1.621-9.085,1.727-1.933,4.449-2.052,6.419-2.052h.693a15.165,15.165,0,0,1,3.911.349,1.23,1.23,0,0,0,.207.061A5.707,5.707,0,0,1-115,18.019c1.577,1.765,2.122,4.82,1.617,9.085-1.434,12.25-5.074,12.254-8.587,12.262A15.5,15.5,0,0,1-124,39.275c-.047-.009-.094-.016-.142-.021-2.748-.42-5.277-2.427-6.42-12.148Zm9.672,14.927c4.612-.206,8.728-2.066,10.2-14.614.038-.328.055-.635.082-.952a9.416,9.416,0,0,0,6.86-4.174c.3-.419.538-1.031.092-1.43C-121.589,12.814-104.3,27.966-120.9,42.028Z"
                          fill="#1fb198"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </v-sheet>
              <div class="d-flex algin-center"></div>
            </v-col>
            <v-col
              cols="5"
              md="3"
              class="d-flex flex-column justify-center align-center"
            >
              <v-sheet
                class="d-flex align-center justify-center pa-6"
                height="100"
                width="100"
                rounded="circle"
                color="transparent"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="45"
                  height="45"
                  viewBox="0 0 45 45"
                >
                  <g
                    id="Grupo_187"
                    data-name="Grupo 187"
                    transform="translate(11 -1122)"
                  >
                    <g id="Icon" transform="translate(-10.467 1122.249)">
                      <rect
                        id="Area"
                        width="45"
                        height="45"
                        transform="translate(-0.533 -0.249)"
                        fill="#fcfcfc"
                        opacity="0"
                      />
                      <g
                        id="Icon-2"
                        data-name="Icon"
                        transform="translate(2.89 5.575)"
                      >
                        <path
                          id="Path"
                          d="M37.016,5.484a10.187,10.187,0,0,0-14.409,0L20.645,7.446,18.683,5.484A10.188,10.188,0,1,0,4.274,19.89l1.964,1.962L20.645,36.261,35.051,21.852l1.964-1.962A10.184,10.184,0,0,0,37.016,5.484Z"
                          transform="translate(-1.29 -2.499)"
                          fill="none"
                          stroke="#1fb198"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2.6"
                        />
                      </g>
                    </g>
                    <g
                      id="Icon-3"
                      data-name="Icon"
                      transform="translate(2.449 1135.449)"
                    >
                      <rect
                        id="Area-2"
                        data-name="Area"
                        width="17"
                        height="17"
                        transform="translate(0.551 0.551)"
                        fill="#fcfcfc"
                        opacity="0"
                      />
                      <g
                        id="Icon-4"
                        data-name="Icon"
                        transform="translate(1.572 2.333)"
                      >
                        <path
                          id="Path-2"
                          data-name="Path"
                          d="M16.879,9.346H13.837l-2.282,6.846L6.991,2.5,4.709,9.346H1.667"
                          transform="translate(-1.667 -2.5)"
                          fill="none"
                          stroke="#1fb198"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2.6"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </v-sheet>
              <div class="d-flex algin-center"></div>
            </v-col>
            <v-col
              cols="5"
              md="3"
              class="d-flex flex-column justify-center align-center"
            >
              <v-sheet
                class="d-flex align-center justify-center pa-6"
                height="100"
                width="100"
                rounded="circle"
                color="transparent"
              >
                <svg
                  id="Icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                >
                  <rect
                    id="Area"
                    width="36"
                    height="36"
                    fill="#fcfcfc"
                    opacity="0"
                  />
                  <g
                    id="Icon-2"
                    data-name="Icon"
                    transform="translate(1.499 1.499)"
                  >
                    <circle
                      id="Path"
                      cx="4.5"
                      cy="4.5"
                      r="4.5"
                      transform="translate(12.001 12.001)"
                      fill="none"
                      stroke="#1fb198"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2.6"
                    />
                    <path
                      id="Path-2"
                      data-name="Path"
                      d="M28.434,21.834a2.476,2.476,0,0,0,.495,2.731l.09.09A3,3,0,1,1,24.773,28.9l-.09-.09a2.5,2.5,0,0,0-4.23,1.769v.256a3,3,0,1,1-6,0V30.7a2.474,2.474,0,0,0-1.62-2.264,2.476,2.476,0,0,0-2.731.495l-.09.09a3,3,0,1,1-4.244-4.246l.09-.09a2.5,2.5,0,0,0-1.769-4.23H3.834a3,3,0,1,1,0-6h.135a2.474,2.474,0,0,0,2.264-1.62A2.476,2.476,0,0,0,5.738,10.1l-.09-.09A3,3,0,1,1,9.894,5.769l.09.09a2.473,2.473,0,0,0,2.729.5h.121a2.473,2.473,0,0,0,1.5-2.264V3.834a3,3,0,1,1,6,0v.135a2.495,2.495,0,0,0,4.23,1.769l.09-.09A3,3,0,1,1,28.9,9.894l-.09.09a2.473,2.473,0,0,0-.495,2.729v.121a2.473,2.473,0,0,0,2.264,1.5h.256a3,3,0,0,1,0,6H30.7A2.473,2.473,0,0,0,28.434,21.834Z"
                      transform="translate(-0.833 -0.833)"
                      fill="none"
                      stroke="#1fb198"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2.6"
                    />
                  </g>
                </svg>
              </v-sheet>
              <div class="d-flex algin-center"></div>
            </v-col>
            <v-col
              cols="5"
              md="3"
              class="d-flex flex-column justify-center align-center"
            >
              <v-sheet
                class="d-flex align-center justify-center pa-4"
                height="100"
                width="100"
                rounded="circle"
                color="transparent"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                >
                  <g id="Icon" transform="translate(0.053)">
                    <rect
                      id="Area"
                      width="36"
                      height="36"
                      transform="translate(-0.053 0)"
                      fill="#fcfcfc"
                      opacity="0"
                    />
                    <g
                      id="Icon-2"
                      data-name="Icon"
                      transform="translate(2.996 2.996)"
                    >
                      <circle
                        id="Path"
                        cx="14.978"
                        cy="14.978"
                        r="14.978"
                        fill="none"
                        stroke="#1fb198"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2.6"
                      />
                      <path
                        id="Path-2"
                        data-name="Path"
                        d="M11.325,2.292c6.546,9.032,9.017,14.109,12.028,26.539M27.158,5.8c-5.572,6.515-13.39,8.476-25.283,8.762M31.082,17.4c-5.243-1.393-9.93-1.228-13.39,0-3.864,1.379-7.5,4.283-11.143,9.467"
                        transform="translate(-1.501 -1.168)"
                        fill="none"
                        stroke="#1fb198"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2.6"
                      />
                    </g>
                  </g>
                </svg>
              </v-sheet>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "receta",
  data: () => ({
    isActive: false,
  }),
};
</script>

<style scoped>

</style>
